import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, multasRenainfPlaca } from './types';

export const INITIAL_STATE: multasRenainfPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): multasRenainfPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.MULTAS_RENAINF_PLACA_REQUEST: {
				break;
			}

			case Types.MULTAS_RENAINF_PLACA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.MULTAS_RENAINF_PLACA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.MULTAS_RENAINF_PLACA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
